<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent type="text" :name="'name'" v-model="formulario.name" :placeholder="'Nome'"
          data-vv-as="Nome" v-validate="'required|min:4'" :error="validationErrors.first('name')" />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent type="text" :name="'email'" v-model="formulario.email" :placeholder="'E-mail'"
          data-vv-as="E-mail" v-validate="'required|email'" :error="validationErrors.first('email')" />
      </div>

      <div class="mb-3">
        <SGPFormSelectComponent name="provedor" :listaDeOptions="listaProvedores" placeholder="Provedor"
          optionLabel="label" optionValue="value" v-model="formulario.provedor" clearable
          data-vv-as="Provedor" :error="validationErrors.first('provedor')" />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent type="password" :name="'password'" v-model="formulario.password" :placeholder="'Senha'"
          data-vv-as="Senha" v-validate="'min:6'" :error="validationErrors.first('password')" />
      </div>

      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
          type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>

        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
          type="button" @click="fecharModal()">
          Cancelar
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "FormularioUsuarioComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    usuario: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      formulario: this.$props.usuario || {
        name: '',
        email: '',
        provedor: null,
        password: ''
      },
      listaProvedores: []
    }
  },

  async created() {
    const provedores = await this.listarProvedores();

    this.listaProvedores = provedores.map(p => ({
      value: p.id,
      label: p.nome
    }));

    this.formulario = {
      ...this.usuario,
      provedor: this.usuario?.ctrl_provedores?.[0]?.id ?? null
    };
  },

  methods: {
    ...mapActions('usuarios', [
      'salvarUsuario',
      'atualizarUsuario',
      'listarProvedores',
      'sincronizarProvedores'
    ]),

    submit() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return;

        let resp;
        const payload = {
          ...this.formulario,
          ...(this.formulario.provedor === null && { provedor: undefined })
        };

        if (this.tipoFormulario === 'salvar') {
          resp = await this.salvarUsuario(payload);
          await this.sincronizarProvedores(payload);
        } else {
          resp = await this.atualizarUsuario(payload);
          await this.sincronizarProvedores(payload);
        }

        if (!resp) return;

        if (this.tipoFormulario === 'editar') {
          this.$emit('usuarioAtualizado');
        }

        this.fecharModal();
      });
    },


    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
